import { render, staticRenderFns } from "./MediumArticleTeaser.vue?vue&type=template&id=9698f274&"
import script from "./MediumArticleTeaser.vue?vue&type=script&lang=js&"
export * from "./MediumArticleTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports